import { Directive, inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import {
  IContract,
  ImmomioIconName,
  ISort,
  QueryParams,
  TicketingVersion,
  TicketSortField,
} from '../../../models';
import { RouterService } from '../../../services';
import {
  getResidentAppSettings,
  getSelectedContract,
  getTicketSorting,
  LoadActiveRequestTicketsForSelectedContract,
  LoadActiveRequestTicketsForSelectedContractHQ,
  LoadArchiveRequestTicketsForSelectedContract,
  LoadArchiveRequestTicketsForSelectedContractHQ,
} from '../../../+state';
import { combineLatest, filter, map, Observable, take, tap } from 'rxjs';

@Directive()
export abstract class TicketsOverviewRequestPageBaseComponent {
  @Input() contractId: string;
  @Input() queryParams: QueryParams;
  public archiveViewOpened = false;
  public immomioIconName = ImmomioIconName;

  protected routerService = inject(RouterService);
  protected route = inject(ActivatedRoute);
  protected store = inject(Store);

  public ticketingVersion$ = this.store.select(getResidentAppSettings).pipe(
    map(response => response?.ticketingVersion),
    filter(response => response !== null)
  );

  protected reloadTickets(): Observable<[IContract, ISort<TicketSortField>]> {
    // TODO: IMPROVEMENT check pagination before reloading
    return combineLatest([
      this.store.select(getSelectedContract),
      this.store.select(getTicketSorting),
    ]).pipe(
      tap(([, sort]) => {
        this.ticketingVersion$.pipe(take(1)).subscribe(version => {
          if (version === TicketingVersion.HIERARCHICAL) {
            this.store.dispatch(
              LoadActiveRequestTicketsForSelectedContractHQ({ offset: 0, limit: 20, sort })
            );
            if (this.archiveViewOpened)
              this.store.dispatch(
                LoadArchiveRequestTicketsForSelectedContractHQ({ offset: 0, limit: 20, sort })
              );
          } else if (version === TicketingVersion.METADATA) {
            this.store.dispatch(
              LoadActiveRequestTicketsForSelectedContract({ offset: 0, limit: 20, sort })
            );
            if (this.archiveViewOpened)
              this.store.dispatch(
                LoadArchiveRequestTicketsForSelectedContract({ offset: 0, limit: 20, sort })
              );
          }
        });
      }),
      take(1)
    );
  }
}
